import React from 'react'
import { LoadingOutlined, LockOutlined, UserAddOutlined } from "@ant-design/icons";

const SimpleLoading = ({ color="#ff2d55", size=25 }) => {
  return (
    <div className='flex justify-center items-center'>
      <LoadingOutlined style={{ color: color, fontSize: size, }} />
    </div>
  )
}

export default SimpleLoading
